module.exports = __webpack_public_path__ + "media/goforajourney/img/madrid-card-cfc0a78c8948824a541d455dfeeeec84.webp";